var Admin = (function () {
    function Admin($rootScope, $timeout, $q, socket, env, $injector, $filter, config, $state, settings) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.env = env;
        this.$injector = $injector;
        this.$filter = $filter;
        this.config = config;
        this.$state = $state;
        this.settings = settings;
        this.selected = null;
        this.listOfCheckList = [
            {
                name: 'Completeness checklist',
                variableName: 'check_list',
                radioButtonName: 'cl_rb',
                description: 'Located in the eligibility tab in the Completeness checklist section',
                visible: false,
                editView: false
            },
            {
                name: 'GOE checklist',
                variableName: 'check_list2',
                radioButtonName: 'cl2_rb',
                description: 'Located in the eligibility tab under the GOE section',
                visible: false,
                editView: false
            },
            {
                name: 'Duplicate checklist',
                variableName: 'check_list3',
                radioButtonName: 'cl3_rb',
                description: 'Located in the eligibility tab under the duplicate check section',
                visible: false,
                editView: false
            },
            {
                name: 'Validation checklist',
                variableName: 'check_list_validation',
                radioButtonName: 'cl_validation_rb',
                description: 'Located in the validation tab',
                visible: false,
                editView: false
            },
            {
                name: 'Sampling Solution checklist',
                variableName: 'check_list_solution_sampling',
                radioButtonName: 'cl_sampling_rb',
                description: 'Located in the sampling solution section',
                visible: false,
                editView: false
            },
            {
                name: 'Sampling SSA checklist',
                variableName: 'check_list_sampling',
                radioButtonName: 'cl_sampling_rb',
                description: 'Located in the sampling ssa section',
                visible: false,
                editView: false
            },
            {
                name: 'Calculation checklist',
                variableName: 'check_list_calculation',
                radioButtonName: 'cl_calculation_rb',
                description: 'Located in the calculation section',
                visible: false,
                editView: false
            },
            {
                name: 'Opportunity Detail checklist',
                variableName: 'check_list_opportunity_detail',
                radioButtonName: 'cl_opportunity_detail_rb',
                description: 'Located in the general section',
                visible: false,
                editView: false
            },
            {
                name: 'Investment Review checklist',
                variableName: 'check_list_investment_review',
                radioButtonName: 'cl_investment_rb',
                description: 'Located in the general section',
                visible: false,
                editView: false
            },
            {
                name: 'Payment checklist',
                variableName: 'check_list_payment',
                radioButtonName: 'cl_payment_rb',
                description: 'Located in the general section',
                visible: false,
                editView: false
            },
            {
                name: 'Exceptions checklist',
                variableName: 'check_list_exceptions',
                radioButtonName: 'cl_exceptions_rb',
                description: 'Located in the general section',
                visible: false,
                editView: false
            }
        ];
        this.clSelection = {
            selected: 'All',
            filters: ['All', 'Active', 'Disabled', 'Not yet enabled']
        };
        this.copySingleLog = undefined;
    }
    Admin.prototype.getCopySingleLog = function () {
        return this.copySingleLog;
    };
    Admin.prototype.setCopySingleLog = function (copySL) {
        this.copySingleLog = copySL;
    };
    Admin.prototype.newLine = function (index, cols) {
        if (index % cols === 0) {
            return true;
        }
        else {
            return false;
        }
    };
    Admin.prototype.navigate = function (where) {
        this.$state.go(where, '');
    };
    Admin.prototype.setProgramID = function (editObj) {
        editObj._id = editObj.country + '|' + editObj.program + '|' + editObj.brand + '|' + editObj.bp_type;
    };
    Admin.prototype.refreshAdvancedFilter = function (table) {
        angular.forEach(table.filters, function (v, k) {
            if (!v) {
                delete table.filterParams[k];
            }
        });
    };
    Admin.prototype.getCountryIOT = function (countrySHORT) {
        var iot = '';
        this.settings.country_list.some(function (cty) {
            if (cty.short === countrySHORT && cty.ic === 'Country') {
                iot = cty.imt;
                return true; //break loop
            }
        });
        return iot;
    };
    Admin.prototype.tidy = function (value) {
        if (angular.isArray(value)) {
            var newValue_1 = '';
            angular.forEach(value, function (ele) {
                if (newValue_1.length > 0) {
                    newValue_1 = newValue_1 + ', ';
                }
                newValue_1 = newValue_1 + ele;
            });
            return newValue_1;
        }
        return value;
    };
    Admin.prototype.getBGName = function (role) {
        if (role === 0) {
            return 'BPSO Administrator';
        }
        else if (role === 1) {
            return 'Non-BPSO Administrator';
        }
        if (role === 2) {
            return 'BPSO Approver';
        }
        if (role === 3) {
            return 'Non-BPSO Approver';
        }
        if (role === 4) {
            return 'Reader';
        }
        if (role === 7) {
            return 'System Administrator';
        }
    };
    Admin.prototype.exportUserPermissions = function () {
        //Make call to get Excel of users' country access
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportUserPermissions',
                script: '/admin/admin-user-excel',
                user: this.env.user
            }
        });
    };
    Admin.prototype.getTermsProfile = function () {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getTermsProfile',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    Admin.prototype.getMiscCodesByType = function (type) {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                code_set: type,
                function: 'getMiscCodesByType',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    Admin.prototype.getListOfAllDisputes = function (data) {
        //Make call to get all disputes
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getListOfAllDisputes',
                script: '/config/config',
                user: this.env.user,
                data: data
            }
        });
    };
    Admin.prototype.getMiscCodes = function (sum) {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getMiscCodes',
                script: '/config/config',
                summary: sum,
                user: this.env.user
            }
        });
    };
    Admin.prototype.updateTerms = function (data) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateTerms',
                script: '/config/config',
                data: data,
                user: this.env.user
            }
        });
    };
    Admin.prototype.updateMiscCodes = function (pack) {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: pack,
                function: 'updateMiscCodes',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    // getGBT20Profile() {
    //     //Make call to get All Program Profiles
    //     this.socket.emit('module', {
    //         module: {
    //             application: 'dmt',
    //             function: 'getGBT20Profile',
    //             script: '/config/config',
    //             user: this.env.user,
    //         }
    //     });
    // }
    Admin.prototype.getGPPLoadProfile = function () {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getGPPLoadProfile',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    Admin.prototype.getSummaryProgramProfiles = function () {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getSummaryProgramProfiles',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getUserProfile = function (email) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getUserProfileByEmail',
                script: '/config/config',
                email: email,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.updateUserProfile = function (data) {
        this.socket.emit('module', {
            application: 'dmt',
            module: {
                function: 'updateUserProfile',
                script: '/config/config',
                data: data.data,
                changelog: data.changelog,
                token: this.env.user.token //To check access
            }
        });
    };
    Admin.prototype.getAllProgramProfiles = function () {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAllProgramProfiles',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getProgramProfileByName = function (name) {
        //Make call to get All Program Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getProgramProfileByName',
                script: '/config/config',
                profile_id: name,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getUserProfiles = function () {
        //Make call to get All User Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getUserProfiles',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getUserProfileByEmail = function (email) {
        //Make call to get All User Profiles
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getUserProfileByEmail',
                script: '/config/config',
                email: email,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getCountryConfig = function () {
        //Make call to get Country settings
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getCountryConfig',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.getGeneralConfig = function () {
        //Make call to get General config
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getGeneralConfig',
                script: '/config/config',
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.updateAdminProfile = function (data) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateAdminProfile',
                script: '/config/config',
                data: data,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.deleteAdminProfile = function (data) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'deleteAdminProfile',
                script: '/config/config',
                data: data,
                token: this.env.user.token
            }
        });
    };
    //getting sampling
    Admin.prototype.getAllCtySamples = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getAllCountrySamplesBackend',
                script: '/sampling/ctrySampling',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    //getting bpoi setup
    Admin.prototype.getBpoiSetup = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getBpoiSetupBackend',
                script: '/admin/bpoi-enabler',
                user: this.env.user
            }
        });
    };
    //add one new Cty to the
    Admin.prototype.addOneCtySample = function (newEntry) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'addCountrySamplesBackend',
                script: '/sampling/ctrySampling',
                data: newEntry,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    //edit all existing country samples
    Admin.prototype.updateAllCtySamples = function (samples) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateAllCtySamplesBackend',
                script: '/sampling/ctrySampling',
                data: samples,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    //getting sampling source
    Admin.prototype.getBaseSamples = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getBaseSamples',
                script: '/sampling/baseTableSampling',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    Admin.prototype.updateBaseSamples = function (newSource, questionsArr) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateBaseSamples',
                script: '/sampling/baseTableSampling',
                data: newSource,
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    ;
    /**
     * Convert a couch property key such as misc_codes or program_template_desc to proper case, ie:
     * Misc Codes, Program Template Desc
     *
     * @param {string} value
     * @returns {string}
     *
     * @memberOf Admin
     */
    Admin.prototype.toProperCase = function (value) {
        if (value.indexOf('_') > -1) {
            var array = value.split('_');
            for (var i = 0; i < array.length; i++) {
                array[i] = array[i].charAt(0).toUpperCase() + array[i].substring(1);
            }
            return array.join(' ');
        }
        return value;
    };
    /**
     * Function to send notification to system Admin team in the event of Admin page update
     *
     * @param {*} bundle
     * @returns
     *
     * @memberOf Admin
     */
    Admin.prototype.sendAdminUpdate = function (bundle) {
        //Bundle should contain
        // - profile - Admin Profile name, ie: Exchange Rate Table
        // - docurl - path of doc updated, ie: exchangerate-view 
        var email = {
            id: 'Admin Profile Update',
            title: bundle.profile,
            to: ['rogersm@uk.ibm.com'],
            subject: 'DMT - Admin Profile Update - ' + bundle.profile,
            message: 'N/A',
            opp: 'N/A',
            bpName: 'N/A',
            fromwho: this.env.user.email,
            template: 'admin-update',
            type: 'mailing',
            event: 'invitation',
            adminUrlPath: bundle.docurl
        };
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendAdminEmail',
                script: '/config/config',
                emailBundle: email,
                token: this.env.user.token
            }
        });
    };
    Admin.$inject = ['$rootScope', '$timeout', '$q', 'socket', 'env', '$injector', '$filter', 'config', '$state', 'settings'];
    return Admin;
}());
angular
    .module('application')
    .service('admin', Admin);
//red - star directive to display red star
angular.module('application')
    .directive('req', function () {
    return {
        template: '<span style="color:red; f">*</span>'
    };
});

//# sourceMappingURL=admin.js.map
